export default "__VITE_ASSET__87af9ca6__"